import API_PATH from '../../../config/API_PATH'
import { DAILY_PRIZE_GUESS, DAILY_PRIZE_GUESSES, DAILY_PRIZE_GUESSES_ALL, DAILY_PRIZE_HISTORY, DAILY_PRIZE_POOL, DAILY_PRIZE_STATUS } from './contants'

export const getDailyPrizeStatus = data => {
	return {
		type: DAILY_PRIZE_STATUS,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.dailyPrizeStatus,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const postDailyPrizeGuess = data => {
	return {
		type: DAILY_PRIZE_GUESS,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.dailyPrizeGuess,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getDailyPrizeHistory = data => {
	return {
		type: DAILY_PRIZE_HISTORY,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.dailyPrizeHistory,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getDailyPrizeGuesses = data => {
	return {
		type: DAILY_PRIZE_GUESSES,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.dailyPrizeGuesses,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getDailyPrizeGuessesAll = data => {
	return {
		type: DAILY_PRIZE_GUESSES_ALL,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.dailyPrizeGuessesAll,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const getDailyPrizePrizePool = data => {
	return {
		type: DAILY_PRIZE_POOL,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.dailyPrizePrizePool,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}